import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import Confirmation from 'components/Confirmation/Confirmation.jsx'

import reserveProduceCancel, { closeCancelConfirmation } from 'state/actions/reserve_produce_cancel'
import {
    CANCEL_CONFIRMATION_TITLE,
    CANCEL_CONFIRMATION_CONTENT,
    CANCEL_CONFIRMATION_SUBMIT,
    CANCEL_CONFIRMATION_CANCEL,
} from './constants.jsx'


export class CancelConfirmation extends React.Component {
    static propTypes = {
        buildingId: PropTypes.number.isRequired,
        opened: PropTypes.bool.isRequired,
        selectedLevel: PropTypes.number.isRequired,
        reserveProduceCancel: PropTypes.func.isRequired,
        handleCloseCancelConfirmation: PropTypes.func.isRequired,
    }
    render() {
        const handleReserveProduceCancel = this.props.reserveProduceCancel.bind(
            null,
            this.props.buildingId,
            this.props.selectedLevel,
        )
        return (
            <Confirmation
                title={CANCEL_CONFIRMATION_TITLE}
                submitCaption={CANCEL_CONFIRMATION_SUBMIT}
                closeCaption={CANCEL_CONFIRMATION_CANCEL}
                opened={this.props.opened}
                onSubmit={handleReserveProduceCancel}
                onClose={this.props.handleCloseCancelConfirmation}
            >
                <p>{CANCEL_CONFIRMATION_CONTENT}</p>
            </Confirmation>
        )
    }
}

const mapStateToProps = (state, { buildingId }) => ({
    buildingId,
    opened: state.reserveProduceCancel.confirmationOpened,
    selectedLevel: state.reserveLevelSelect.selectedLevel,
})

const mapDispatchToProps = {
    reserveProduceCancel,
    handleCloseCancelConfirmation: closeCancelConfirmation,
}

export default connect(mapStateToProps, mapDispatchToProps)(CancelConfirmation)



// WEBPACK FOOTER //
// ./containers/BuildingCard/components/CancelConfirmation/CancelConfirmation.jsx